import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TaskStatusToggle, TaskStatusType } from '../../../../../Task'
import { useCalendarContext } from '../../../../Calendar.hooks'

function CalendarItemCardStepDone({ step }) {
  const { t } = useTranslation()

  const { onChangeTaskStatus } = useCalendarContext()

  const [isLoading, setLoading] = useState(false)

  function handleChange() {
    setLoading(true)

    onChangeTaskStatus({ changes: { done: !step.isDone }, task: step }).finally(
      () => {
        setLoading(false)
      }
    )
  }

  return (
    <TaskStatusToggle
      checked={step.isDone}
      disabled={!step.canEdit}
      isLoading={isLoading}
      tooltip={t(
        step.isDone
          ? 'TaskTable.ActionMarkAsOpenTooltipKey'
          : 'TaskTable.ActionMarkAsDoneTooltipKey'
      )}
      type={TaskStatusType.Done}
      onChange={handleChange}
    />
  )
}

export default CalendarItemCardStepDone
